import { RetryLink } from "@apollo/client/link/retry";
export const retryLink = () => {
    return new RetryLink({
        attempts: {
            max: 3,
        },
        delay: {
            initial: 300,
        },
    });
};
//# sourceMappingURL=retry-link.js.map